import { useCallback, useEffect, useMemo, useRef } from "react";

import { useNode } from "@craftjs/core";
import { debounce } from "lodash";

import { define, prop } from "../../utils"
import BasePreview from "../base"

import { useNavigationContext } from "./context";

function NavigationItemPreview({ label, ...props }) {
  useNavigationItem()

  return <li>
    <BasePreview {...props}>
      <a>
        {label}
      </a>
    </BasePreview>
  </li>
}

export function useNavigationItem() {
  const { properties, actions: { setProp } } = useNode(({ data: { props: { properties } } }) => ({ properties }));
  const { itemProps: { setValue: setContext, value: context } } = useNavigationContext()

  const mounted = useRef(false)

  const setState = useCallback(state => {
    setProp(props => {
      props.properties = state
    })
  }, [setProp])

  const setDebouncedState = useMemo(() => debounce(setState, 10), [setState])

  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true
      setState(context)
    }
  }, [context, setState])

  useEffect(() => {
    if (mounted.current && properties) {
      setContext(properties)
    }
  }, [properties, setContext])

  useEffect(() => {
    if (context) {
      setDebouncedState(context)
    }
  }, [context, setDebouncedState])
}

function NavigationItemHTML({ attributes, target }) {
  return <li>
    <a href="{{url}}" {...attributes} target={target || undefined}>
      {`{{label}}`}
    </a>
  </li>
}

export default define('navigation-item', NavigationItemPreview, NavigationItemHTML)
  .property(prop.stylePattern())
  .property(prop.predefined.customClass())
  .property(...prop.predefined.typography())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(prop.predefined.attributes())
  .property(prop.predefined.target().ignoreDevice(true))
  .build()
